import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const events = [
  {
    year: '2025',
    title: 'Prima coerență cuantică susținută',
    detail: 'Zurich, 2:17 AM, 14 octombrie. Scânteia din care a început totul.',
    body: 'Dr. Elena Vasquez înregistrează primul moment de coerență cuantică susținută — 0,8 secunde, fidelitate 0,9997.',
    tag: 'Trezire',
    color: 'amber',
  },
  {
    year: '2058',
    title: 'Vârful populației Pământului: 7,4 miliarde',
    detail: 'Planeta la limita sa maximă — resursele, clima și sistemele politice sunt la punctul de rupere.',
    body: 'Populația Pământului atinge vârful: 7,4 miliarde de oameni.',
    tag: 'Pământ',
    color: 'green',
  },
  {
    year: '2060',
    title: '40% din locurile de muncă automatizate',
    detail: 'Criza automatizării declanșează epidemia globală a lipsei de sens.',
    body: '40% din locurile de muncă existente în 2025 sunt automatizate.',
    tag: 'Criză',
    color: 'red',
  },
  {
    year: '2067–2070',
    title: 'Pandemia Marburg-X',
    detail: 'Cel mai devastator eveniment al secolului. Lumea este forțată să aleagă ce vrea să devină.',
    body: '340 de milioane de vieți pierdute în trei ani.',
    tag: 'Criză',
    color: 'red',
  },
  {
    year: '2071',
    title: 'Primul procesor cuantic stabil',
    detail: 'Scânteia Trezirii Cuantice. Punctul de inflexiune al civilizației.',
    body: 'Dr. Elena Vasquez creează primul procesor cuantic stabil funcțional.',
    tag: 'Trezire',
    color: 'amber',
  },
  {
    year: '2078',
    title: 'Primul upload de conștiință',
    detail: 'Primul om care există simultan în formă biologică și cuantică.',
    body: 'Dr. Elena Vasquez realizează primul upload de conștiință — al său.',
    tag: 'Descoperire',
    color: 'yellow',
  },
  {
    year: '2082',
    title: 'Misterul gravitației cuantice rezolvat',
    detail: 'Relativitatea generală și mecanica cuantică unificate într-un singur cadru coerent.',
    body: 'Primul Colectiv cuantic rezolvă misterul gravitației cuantice.',
    tag: 'Știință',
    color: 'blue',
  },
  {
    year: '2087',
    title: 'Fuziunea nucleară susținută — câștig net 47:1',
    detail: 'Energia devine atât de abundentă încât măsurarea ei devine absurdă.',
    body: 'Reactorul Tanaka-Osei atinge fuziunea nucleară susținută.',
    tag: 'Energie',
    color: 'orange',
  },
  {
    year: '2093',
    title: 'Colectivul Medical de Conștiință fondat',
    detail: '847 de cercetători conectați cuantic. Prima țintă: cancerul.',
    body: 'Dr. Amara Osei fondează Colectivul Medical de Conștiință.',
    tag: 'Medicină',
    color: 'green',
  },
  {
    year: '2098',
    title: 'Cancerul eliminat',
    detail: 'Secțiile de oncologie din lumea întreagă își închid ușile.',
    body: 'Cancerul este eliminat efectiv prin nanoparticule programabile.',
    tag: 'Medicină',
    color: 'green',
  },
  {
    year: '2103',
    title: 'Bolile cardiovasculare eliminate',
    detail: 'Infarcturile și accidentele vasculare devin la fel de rare ca variola.',
    body: 'Bolile cardiovasculare sunt eliminate prin terapii genetice și mașini moleculare.',
    tag: 'Medicină',
    color: 'green',
  },
  {
    year: '2108',
    title: 'Neurodegenerarea reversată',
    detail: '"Îmi amintesc acum. Uitasem cum se simte să gândești clar cu acest creier." — Dr. Vasquez, 108 ani',
    body: 'Alzheimer, Parkinson, SLA — reversate. Dr. Vasquez este printre primii pacienți.',
    tag: 'Medicină',
    color: 'green',
  },
  {
    year: '2110',
    title: 'Erebus Station — prima colonie permanentă pe Mercur',
    detail: 'Prima casă permanentă a umanității în afara Pământului.',
    body: 'Bazinul Caloris. Umanitatea devine o specie cu mai mult de o casă.',
    tag: 'Expansiune',
    color: 'orange',
  },
  {
    year: '2120',
    title: 'Un miliard de oameni realizează uploadul de conștiință',
    detail: 'Un sfert din populația supraviețuitoare a Pământului există acum și în formă cuantică.',
    body: 'Granița dintre biologic și digital devine permeabilă pentru mase.',
    tag: 'Descoperire',
    color: 'yellow',
  },
  {
    year: '2125',
    title: 'Rețeaua Shared Discovery Network lansată',
    detail: 'Un nou sistem economic bazat pe contribuție și colaborare, nu pe raritate și competiție.',
    body: 'SDN — primul sistem post-scarcity de organizare economică globală.',
    tag: 'Societate',
    color: 'purple',
  },
  {
    year: '2130',
    title: 'Îmbătrânirea biologică devine reversibilă',
    detail: 'Moartea devine, pentru prima dată în istoria vieții pe Pământ, o alegere.',
    body: 'Primul set complet de intervenții cuantice anti-îmbătrânire.',
    tag: 'Descoperire',
    color: 'yellow',
  },
  {
    year: '2155',
    title: 'Companionii Psihologici Cuantici distribuiți global',
    detail: 'Prima dată în istorie, fiecare om are acces la un sistem care îl înțelege mai bine decât se înțelege pe sine.',
    body: 'QPC — revoluție în sănătatea mentală și înțelegerea de sine.',
    tag: 'Societate',
    color: 'purple',
  },
  {
    year: '2180',
    title: 'Terraformarea lui Marte începe',
    detail: 'Primele cupole urbane răsar în deșerturile roșii.',
    body: 'Cel mai ambițios proiect de inginerie planetară de până acum.',
    tag: 'Expansiune',
    color: 'red',
  },
  {
    year: '2200',
    title: 'Uploadul de conștiință devine universal',
    detail: 'Orice copil născut în 2200 are un sine cuantic din naștere.',
    body: 'Umanitatea transcende granița dintre biologic și digital la nivel de civilizație.',
    tag: 'Descoperire',
    color: 'yellow',
  },
  {
    year: '2220',
    title: 'Primele colonii permanente în Centura de Asteroizi',
    detail: 'Belter-ii îți dezvoltă propria limbă și cultură.',
    body: 'Mineri, comercianți și rătăcitori — o civilizație construită în jurul mișcării și autoîntreținerii.',
    tag: 'Expansiune',
    color: 'gray',
  },
  {
    year: '2260',
    title: 'Sistemul jovian colonizat',
    detail: 'Lunile de gheață devin sursa de apă care va hrăni terraformarea Venusului.',
    body: 'Callisto, Ganymede, Europa — primele colonii permanente dincolo de Centura de Asteroizi.',
    tag: 'Expansiune',
    color: 'blue',
  },
  {
    year: '2290',
    title: 'Terraformarea Venusului inițiată',
    detail: 'Cel mai ambițios proiect de inginerie planetară din istoria umanității.',
    body: 'Parasolar Ishtar implementat. 97 de ani de livrare a gheții din Jupiter abia încep.',
    tag: 'Expansiune',
    color: 'amber',
  },
  {
    year: '2310',
    title: 'Helios Array conceput — 12.000 de colectoare solare',
    detail: 'Va produce în 45 de minute echivalentul întregii energii consumate în secolul 21.',
    body: 'Rețeaua orbitală în jurul lui Mercur — coloana vertebrală energetică a civilizației solare.',
    tag: 'Energie',
    color: 'orange',
  },
  {
    year: '2310',
    title: 'Valhalla Station pe Callisto — Misiunea Galileo',
    detail: '2.000 de coloniști. Prima așezare permanentă în afara sistemului solar interior.',
    body: 'Umanitatea depășește centura de asteroizi și se stabilește în sistemul jovian.',
    tag: 'Expansiune',
    color: 'blue',
  },
  {
    year: '2345',
    title: 'Atmospheric Harvesting Initiative — Heliu-3 din Jupiter',
    detail: '3.000 de drone autonome în rotație continuă. Combustibilul civilizației solare pentru milioane de ani.',
    body: 'Extracția de He-3 din atmosfera lui Jupiter alimentează fuziunea pe opt lumi.',
    tag: 'Energie',
    color: 'orange',
  },
  {
    year: '2400',
    title: 'Republica Marțiană — independentă politic și cultural',
    detail: 'Prima civilizație planetară distinctă — cu propria identitate, propria filozofie, propria voce.',
    body: 'Marte nu mai este o colonie. Este o națiune.',
    tag: 'Societate',
    color: 'red',
  },
  {
    year: '2418',
    title: 'Triton Station fondată — la -235°C',
    detail: 'Cel mai îndepărtat post uman permanent. Santinelele care privesc marginea sistemului solar.',
    body: 'Umanitatea ajunge la Neptun. Ingineria de materiale atinge limitele absolute.',
    tag: 'Expansiune',
    color: 'blue',
  },
  {
    year: '2450',
    title: 'Titan — centrul cultural al sistemului solar',
    detail: 'Artiști, filozofi și contemplatori în lacurile de hidrocarburi sub inelele lui Saturn.',
    body: 'Colonia Titan devine locul unde civilizația solară reflectează asupra propriei naturi.',
    tag: 'Societate',
    color: 'purple',
  },
  {
    year: '2462',
    title: 'New Cythera fondată pe Venus',
    detail: '"I-am spus iad. Noi l-am numit pânză. Și în două secole l-am pictat într-o lume." — Guvernatoarea Celestine Moreau',
    body: 'Prima capitală a lumii complet terraformate. Discursul de Fondare, 2462.',
    tag: 'Expansiune',
    color: 'amber',
  },
  {
    year: '2480',
    title: 'Compact Gaia semnat',
    detail: 'Construit pe lecțiile aproape-distrugerii Pământului. Memoria colectivă ca fundament al guvernării.',
    body: 'Cadrul politic și filozofic care unește civilizația solară. Opt lumi. Un legământ.',
    tag: 'Societate',
    color: 'green',
  },
  {
    year: '2501',
    title: 'Venus — un milion de locuitori',
    detail: 'Cel mai frumos loc creat vreodată de mâna omului.',
    body: 'Oceane calde, ceruri ambrate, plaje de nisip negru. Două secole de muncă. Un paradis.',
    tag: 'Piatră de hotar',
    color: 'amber',
  },
  {
    year: '2501',
    title: 'Pământul: 3 miliarde — față de 7,4 miliarde în 2058',
    detail: 'Nu statistici — prețul unei civilizații care a știut și a ales să nu acționeze la timp.',
    body: '4,4 miliarde de oameni pierduți. Profesori din Kinshasa, fermieri din Mumbai inundat, ingineri de apă.',
    tag: 'Prețul',
    color: 'red',
  },
  {
    year: '2514',
    title: 'Proiectul Odyssey — prima misiune interstelară',
    detail: 'Opt lumi își sting luminile simultan — Vigilia Luminilor — pulsând ca un singur corp respirând.',
    body: '120 de persoane. Triton Station → Alpha Centauri, 4,37 ani-lumină. Umanitatea pleacă spre stele.',
    tag: 'Odiseea',
    color: 'indigo',
  },
  {
    year: '2514 · +11 zile',
    title: 'Semnalul detectat',
    detail: 'Posibil călătorind de milioane de ani. Cronica se termină deliberat neterminată.',
    body: 'Recursiv. Auto-referențial. Cu densitatea informațională a unui spirit. Dintr-o direcție pe care nicio sursă stelară cunoscută nu o poate explica.',
    tag: 'Semnal',
    color: 'blue',
  },
];

const tagColors = {
  Trezire: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  Pământ: 'bg-green-500/20 text-green-400 border-green-500/30',
  Criză: 'bg-red-500/20 text-red-400 border-red-500/30',
  Descoperire: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  Știință: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  Energie: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  Medicină: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  Expansiune: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  Societate: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  'Piatră de hotar': 'bg-amber-500/20 text-amber-300 border-amber-400/30',
  Prețul: 'bg-red-900/30 text-red-300 border-red-500/30',
  Odiseea: 'bg-indigo-500/20 text-indigo-300 border-indigo-500/30',
  Semnal: 'bg-blue-900/30 text-blue-300 border-blue-500/30',
};

const dotColors = {
  amber: 'bg-amber-400 shadow-amber-400/50',
  green: 'bg-green-400 shadow-green-400/50',
  red: 'bg-red-400 shadow-red-400/50',
  yellow: 'bg-yellow-400 shadow-yellow-400/50',
  blue: 'bg-blue-400 shadow-blue-400/50',
  orange: 'bg-orange-400 shadow-orange-400/50',
  purple: 'bg-purple-400 shadow-purple-400/50',
  gray: 'bg-gray-400 shadow-gray-400/50',
  indigo: 'bg-indigo-400 shadow-indigo-400/50',
};

const TimelineEventRo = ({ event, index }) => {
  const [open, setOpen] = useState(false);
  const dot = dotColors[event.color] || dotColors.amber;
  const tag = tagColors[event.tag] || tagColors.Trezire;

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.03 }}
      className="relative flex gap-6 group"
    >
      <div className="flex-shrink-0 flex flex-col items-center">
        <div className={`w-3 h-3 rounded-full mt-5 flex-shrink-0 shadow-lg ${dot}`}></div>
        <div className="w-px flex-1 bg-white/5 mt-2"></div>
      </div>

      <div className="flex-1 pb-6">
        <button
          onClick={() => setOpen(!open)}
          className="w-full text-left bg-brand-dark border border-white/5 rounded-xl p-5 hover:border-white/10 transition-all duration-200"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-3 mb-2">
                <span className="text-brand-accent font-display font-bold text-base">{event.year}</span>
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${tag}`}>
                  {event.tag}
                </span>
              </div>
              <h4 className="text-white font-semibold text-base leading-snug">{event.title}</h4>
            </div>
            <span className={`text-gray-600 text-lg flex-shrink-0 transition-transform duration-300 mt-1 ${open ? 'rotate-180' : ''}`}>
              ↓
            </span>
          </div>

          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="overflow-hidden"
              >
                <div className="mt-4 pt-4 border-t border-white/5 space-y-2">
                  <p className="text-gray-300 leading-relaxed text-sm">{event.body}</p>
                  <p className="text-gray-500 text-xs italic leading-relaxed">{event.detail}</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </button>
      </div>
    </motion.div>
  );
};

const FullTimelineRo = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Cinci Secole de Istorie" subtitle="Cronologie Completă" />
      <p className="text-gray-400 text-center mb-12 leading-relaxed">
        De la prima scânteie de coerență cuantică într-un laborator din Zürich până la un semnal sosind din stele —
        fiecare moment care a modelat ascensiunea umanității.
      </p>
      <div className="space-y-0">
        {events.map((event, i) => (
          <TimelineEventRo key={i} event={event} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default FullTimelineRo;